module.exports = __webpack_public_path__ + "static/media/Tech.9621dd7a.png";